// JavaScript Document

jQuery(".coleql_height").matchHeight();

jQuery(window).on("load", function () {
  if (jQuery(".template").val() == "customers/login") {
    setTimeout(function () {
      jQuery(".coleql_height").matchHeight();
    }, 1000);
  }
});

jQuery(document).ready(function ($) {
  $(document).on("click", ".video-icon", function () {
    $(".video-popup").addClass("video-popup-active");
    $("body").css("overflow-y", "hidden");
  });

  $(document).on("click", ".video-pop-close", function () {
    $(".video-popup").removeClass("video-popup-active");
    $("body").css("overflow-y", "scroll");
  });

  jQuery(".stellarnav").stellarNav({
    theme: "light",

    breakpoint: 1199,

    position: "right",
  });

  jQuery("#relatedpost").loadMore({
    selector: "li",

    loadBtn: "#btn",

    limit: 3,

    load: 6,

    animate: true,

    animateIn: "fadeInUp",
  });
});

jQuery(window).scroll(function () {
  if ($(".header").offset().top > 0) {
    jQuery(".header").addClass("fixed-header");
  } else {
    jQuery(".header").removeClass("fixed-header");
  }
});

jQuery(document).ready(function () {
  var owl = jQuery(".CarouselOwl");

  owl.owlCarousel({
    margin: 30,

    nav: false,

    loop: false,

    dots: false,

    responsive: {
      0: { items: 1, loop: true },

      480: { items: 1, loop: true },

      576: { items: 1, loop: true },

      768: { items: 2, loop: true },

      992: { items: 3, loop: false },

      1200: { items: 3, loop: false },
    },
  });
});

jQuery(document).ready(function () {
  var owl = jQuery(".CarouselOwlQuote");

  owl.owlCarousel({
    margin: 30,

    nav: false,

    loop: true,

    dots: true,
    autoplayTimeout: 10000,
    responsive: {
      0: { items: 1, loop: true },

      480: { items: 1, loop: true },

      576: { items: 1, loop: true },

      768: { items: 1, loop: true },

      992: { items: 1, loop: false },

      1200: { items: 1, loop: false },
    },
  });
});

if ($("#r-latest-news-slider").length > 0) {
  var owl = $("#r-latest-news-slider").owlCarousel({
    loop: true,
    margin: 30,
    items: 1,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });
  $("#r-latest-news-slider").on("mouseenter", function (e) {
    console.log("mouse enter");
    owl.trigger("play.owl.autoplay", [1000]);
  });
}

jQuery(function () {
  jQuery("#side-menu").metisMenu();
});

jQuery(document).ready(function () {
  jQuery(".main-menu li a").each(function () {
    if (jQuery(this).next().length > 0) {
      jQuery(this).addClass("parent");
    }
  });
});

!(function (a, b, c) {
  function d(b, c) {
    (this.element = a(b)),
      (this.settings = a.extend({}, f, c)),
      (this._defaults = f),
      (this._name = e),
      this.init();
  }
  var e = "metisMenu",
    f = { toggle: !0, doubleTapToGo: !1 };
  (d.prototype = {
    init: function () {
      var b = this.element,
        d = this.settings.toggle,
        f = this;
      this.isIE() <= 9
        ? (b.find("li.active").has("ul").children("ul").collapse("show"),
          b.find("li").not(".active").has("ul").children("ul").collapse("hide"))
        : (b.find("li.active").has("ul").children("ul").addClass("collapse in"),
          b
            .find("li")
            .not(".active")
            .has("ul")
            .children("ul")
            .addClass("collapse")),
        f.settings.doubleTapToGo &&
          b.find("li.active").has("ul").children("a").addClass("doubleTapToGo"),
        b
          .find("li")
          .has("ul")
          .children("a")
          .on("click." + e, function (b) {
            return (
              b.preventDefault(),
              f.settings.doubleTapToGo &&
              f.doubleTapToGo(a(this)) &&
              "#" !== a(this).attr("href") &&
              "" !== a(this).attr("href")
                ? (b.stopPropagation(),
                  void (c.location = a(this).attr("href")))
                : (a(this)
                    .parent("li")
                    .toggleClass("active")
                    .children("ul")
                    .collapse("toggle"),
                  void (
                    d &&
                    a(this)
                      .parent("li")
                      .siblings()
                      .removeClass("active")
                      .children("ul.in")
                      .collapse("hide")
                  ))
            );
          });
    },
    isIE: function () {
      for (
        var a,
          b = 3,
          d = c.createElement("div"),
          e = d.getElementsByTagName("i");
        (d.innerHTML = "<!--[if gt IE " + ++b + "]><i></i><![endif]-->"), e[0];

      )
        return b > 4 ? b : a;
    },
    doubleTapToGo: function (a) {
      var b = this.element;
      return a.hasClass("doubleTapToGo")
        ? (a.removeClass("doubleTapToGo"), !0)
        : a.parent().children("ul").length
        ? (b.find(".doubleTapToGo").removeClass("doubleTapToGo"),
          a.addClass("doubleTapToGo"),
          !1)
        : void 0;
    },
    remove: function () {
      this.element.off("." + e), this.element.removeData(e);
    },
  }),
    (a.fn[e] = function (b) {
      return (
        this.each(function () {
          var c = a(this);
          c.data(e) && c.data(e).remove(), c.data(e, new d(this, b));
        }),
        this
      );
    });
})(jQuery, window, document);

jQuery(".slider-for").slick({
  slidesToShow: 1,

  slidesToScroll: 1,

  arrows: false,

  fade: false,

  asNavFor: ".slider-nav",
});

jQuery(".slider-nav").slick({
  slidesToShow: 4,

  slidesToScroll: 1,

  //vertical:true,

  asNavFor: ".slider-for",

  dots: false,

  focusOnSelect: true,

  verticalSwiping: true,

  responsive: [
    {
      breakpoint: 992,

      settings: {
        //vertical: false,
      },
    },

    {
      breakpoint: 768,

      settings: {
        //vertical: false,
      },
    },

    {
      breakpoint: 580,

      settings: {
        //vertical: false,

        slidesToShow: 4,
      },
    },

    {
      breakpoint: 380,

      settings: {
        //vertical: false,

        slidesToShow: 4,
      },
    },
  ],
});

jQuery("#blogpost").loadMore({
  selector: "li",

  loadBtn: "#btn",

  limit: 12,

  load: 6,

  animate: true,

  animateIn: "fadeInUp",
});

jQuery("#testimonial").loadMore({
  selector: "li",

  loadBtn: "#btn",

  limit: 16,

  load: 6,

  animate: true,

  animateIn: "fadeInUp",
});

jQuery(".update_cart").on("click", function () {
  jQuery(this).parents("form").submit();
});

var $ = jQuery;
$(".prod-item").each(function (e) {
  var _this = $(this);
  $(this)
    .find(".pro-item-slider-for")
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: _this.find(".pro-item-slider-nav"),
    });

  _this.find(".pro-item-slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: _this.find(".pro-item-slider-for"),
    dots: false,
    centerMode: false,
    focusOnSelect: true,
  });
});

$(".popup").on("click", function(e) {
  e.preventDefault();
  $(".new-modal").show();
  $(".new-modal-overlay").show();
});

$(document).on("click", function(e) {
  if(e.target.closest(".new-modal-overlay")) {
    $(".new-modal").hide();
    $(".new-modal-overlay").hide();
  }

  // Auto-apply LARA20 discount code on Lara landing page
  if (window.location.pathname === '/pages/lara') {
    fetch('/discount/LARA20', { method: 'GET', redirect: 'manual' });
    }
});